import UK from "./UK.png";
import RU from "./RU.png";

export const flags = {
    RU: {
        name: "RU",
        img: RU,
        full: "Русский",
        short: "rus"
    },
    EN: {
        name: "UK",
        img: UK,
        full: "English",
        short: "eng"
    },
};
